import { createWithEqualityFn } from 'zustand/traditional';
import { persist } from "zustand/middleware";
import { createJSONStorage } from 'zustand/middleware';
import { ItemDto } from '../common/dtos/initData.dto';

interface MenuItemInterface {
  name: string;
  route: string;
  icon: string;
  order: number;
}

interface MenuInterface {
  module: string;
  icon: string;
  order: number;
  items: MenuItemInterface[];
}

// Constante del menú (ejemplo)
const MENU_CONST: MenuInterface[] = [
  {
    module: 'Configuración',
    icon: 'settings',
    order: 1,
    items: [
      {
        name: 'Roles',
        route: '/admin/roles',
        icon: 'grid_view',
        order: 1
      },
      {
        name: 'Usuarios',
        route: '/admin/users',
        icon: 'users-cog',
        order: 2
      },
    ]
  },
  // {
  //   module: 'Reportes',
  //   icon: 'settings',
  //   order: 3,
  //   items: [
  //     {
  //       name: 'Vencimientos',
  //       route: '/reports/expirations',
  //       icon: 'grid_view',
  //       order: 1
  //     },
  //     {
  //       name: 'Reversiones',
  //       route: '/reports/reversions',
  //       icon: 'grid_view',
  //       order: 2
  //     }
  //   ]
  // },
];

// Función para mapear MENU_CONST a ItemDto[]
function mapMenuToItems(menu: MenuInterface[]): ItemDto[] {
  let currentId = 1;

  return menu.map((m) => {
    return {
      id: currentId++,
      moduleId: 0, // Ajusta según tus necesidades
      name: m.module,
      route: '', // El módulo principal podría no tener ruta
      icon: m.icon,
      showMenu: 1,
      isReport: 0,
      permissions: [],
      children: m.items.map((i) => ({
        id: currentId++,
        moduleId: 0, // Ajusta según sea necesario
        name: i.name,
        route: i.route,
        icon: i.icon,
        showMenu: 1,
        isReport: 0,
        permissions: [],
        children: [],
        domainUrl: '' // Ajusta si es necesario
      })),
      domainUrl: '' // Ajusta si es necesario
    };
  });
}

// Mapeamos el menú a ItemDto[]
const mappedItems: ItemDto[] = mapMenuToItems(MENU_CONST);

type ItemsState = {
  items: ItemDto[];
  setItems: (items: ItemDto[]) => void;
  clearItems: () => void;
};

// Crear un almacenamiento personalizado
const storage = createJSONStorage(() => localStorage);

export const useItemsStore = createWithEqualityFn<ItemsState>()(
  persist(
    (set) => ({
      // Estado inicial utilizando la constante mapeada
      items: mappedItems,
      setItems: (items: ItemDto[]) => set({ items }),
      clearItems: () => set({ items: [] })
    }),
    {
      name: 'items-storage',
      storage,
    }
  )
);
